import { MapContainer, TileLayer} from "react-leaflet";
import { useState, useEffect } from "react";
import 'leaflet/dist/leaflet.css';
import DetectorMarker from './DetectorMarker';
import authHeader from "../../services/auth-header";

import { useTranslation } from "react-i18next";

const api = require("../../api/names.js");

function MySimpleMap(props){
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  const { t } = useTranslation("common");

  useEffect(() => {

    var url = api.baseUrl+'/detectorsEUIs/WithGPSByParkingID/';
    url += props.parkingID;
    //console.log(url);
    fetch(url, {
  method: 'get',
  headers: authHeader()
  })
    .then(res => res.json())
    .then(
      (result) => {
        //console.log(result);
        setIsLoaded(true);
        setItems(result);
      },
      (error) => {
        setIsLoaded(true);
        setError(error);
      }
    )
  },[props.parkingID])


  function GetZoom()
  {
    if(props.parkingID === 4)
      return 17;
    else
      return 19;
  }

  if (error) {
    return <div>{t('detectord.error')}{error.message}</div>;
   } else if (!isLoaded) {
    return <div>{t('detectord.loading')}</div>;
   } else {
  return (
  <div>

    <MapContainer className="map" center={[props.gpsLatitude, props.gpsLongtitude]} zoom={GetZoom()}>
      <TileLayer
        maxZoom={19}
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {items.map((item,index) => (
        <DetectorMarker key={index} address={item.address} positionOnParking={item.positionOnParking} lat={item.detectorsGpsLocation.gpsLatitude} lon={item.detectorsGpsLocation.gpsLongtitude} color="yellow" radius={3} parkingID={props.parkingID} markDetectors={props.markDetectors} />

      ))}


    </MapContainer>

    </div>
  );
  }
};

export default MySimpleMap;
